import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { TaskModel } from '@smarttask-common/src/lib/models/Record/Task/Core/TaskModel';

export enum TaskActionTypes {
    ADD_TASK = '[Task] Create Task',
    ADD_TASKS = '[Task] Add Tasks',
    UPSERT_TASK = '[Task] Upsert Task',
    UPSERT_TASKS = '[Task] Upsert Tasks',
    UPDATE_TASK = '[Task] Update Task',
    UPDATE_TASKS = '[Task] Update Tasks',
    DELETE_TASK = '[Task] Delete Task',
    DELETE_TASKS = '[Task] Delete Tasks',
    DELETE_ALL_TASKS = '[Task] Delete All Tasks',
    DELETE_ALL = '[Task] Delete All',

    UPDATE_SELECTED_ID = '[Task] Update SelectedId',
}

export class UpdateSelectedTaskId implements Action {
    readonly type = TaskActionTypes.UPDATE_SELECTED_ID;
    constructor(public selected_record_id: string) {}
}

export class AddOne implements Action {
    readonly type = TaskActionTypes.ADD_TASK;
    constructor(public task: TaskModel) {}
}

export class AddMany implements Action {
    readonly type = TaskActionTypes.ADD_TASKS;
    constructor(public tasks: Array<TaskModel>) {}
}

export class UpsertOne implements Action {
    readonly type = TaskActionTypes.UPSERT_TASK;

    constructor(public task: TaskModel) {}
}

export class UpsertMany implements Action {
    readonly type = TaskActionTypes.UPSERT_TASKS;
    constructor(public tasks: Array<TaskModel>) {}
}

export class UpdateOne implements Action {
    readonly type = TaskActionTypes.UPDATE_TASK;
    constructor(public task: Update<TaskModel>) {}
}

export class UpdateMany implements Action {
    readonly type = TaskActionTypes.UPDATE_TASKS;
    constructor(public tasks: Array<Update<TaskModel>>) {}
}

export class DeleteOne implements Action {
    readonly type = TaskActionTypes.DELETE_TASK;
    constructor(public id: string) {}
}

export class DeleteMany implements Action {
    readonly type = TaskActionTypes.DELETE_TASKS;
    constructor(public ids: Array<string>) {}
}

export class DeleteAll implements Action {
    readonly type = TaskActionTypes.DELETE_ALL_TASKS;
    constructor(public ids: Array<string>) {}
}

export class DeleteState implements Action {
    readonly type = TaskActionTypes.DELETE_ALL;
    constructor() {}
}

export type TaskActions =
    | AddOne
    | AddMany
    | UpsertOne
    | UpsertMany
    | DeleteOne
    | DeleteMany
    | DeleteAll
    | DeleteState
    | UpdateOne
    | UpdateMany
    | UpdateSelectedTaskId;
